export default function(prismicLocale) {
    return {
        'sv-se': 'https://kreditkort.com',
        'no': 'https://kredittkort360.com',
        'fi': 'https://luottokortit.com',
        'de-de': 'https://kreditkarten360.com',
        'en-ca': 'https://creditcards360.ca'
    }[prismicLocale];
}